import {
  CodeConfigurationField,
  LandingPageDestination
} from '@dtx-company/inter-app/src/types/flowcode'
import { FC, useRef } from 'react'
import { TextField } from '@dtx-company/design-system/src'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import {
  selectError,
  selectNormalizedScanDestination
} from '@app/code/src/machines/locg/locgSelectors'
import { useGlobalServices } from '@app/common/src/hooks/useGlobalServices'
import { useOnChange } from '../hooks/useOnChange'
import { useOnErrorScrollInToView } from '../hooks/useOnErrorScrollInToView'
import { useScanDestinationOptions } from '../hooks/useScanDestinationOptions'
import { useSelector } from '@xstate/react'
import useTranslation from 'next-translate/useTranslation'

export const GoogleDocField: FC = () => {
  const { t } = useTranslation('logged-out-generator')
  const scanDestinationOptions = useScanDestinationOptions()
  const { locgService } = useGlobalServices()
  const normalizedScanDestination = useSelector(locgService, selectNormalizedScanDestination)
  const { Icon } = scanDestinationOptions[LandingPageDestination.GOOGLE_DOC]
  const error = useSelector(locgService, selectError)(CodeConfigurationField.SCAN_DESTINATION)
  const ref = useRef<HTMLInputElement>(null)
  useOnErrorScrollInToView(Boolean(error), ref)

  const onChange = useOnChange()

  return (
    <TextField
      size="large"
      name={CodeConfigurationField.SCAN_DESTINATION}
      label={t('LoggedOutGenerator.ScanDestination.options.googleDocs.label')}
      hiddenLabel
      value={normalizedScanDestination}
      placeholder={t(
        'LoggedOutGenerator.ScanDestination.options.googleDocs.subcomponents.GoogleDocInput.placeholder'
      )}
      type="url"
      startAdornment={
        <Icon sx={{ display: { xs: 'none', md: 'block' }, color: 'onSurface.secondary' }} />
      }
      onChange={onChange}
      onFocus={() => fireAnalyticsEvent('LoggedOutGenerator_ScanDestinationInputGoogleDoc_Focused')}
      onBlur={e => {
        fireAnalyticsEvent('LoggedOutGenerator_ScanDestinationInputGoogleDoc_Blurred', {
          text: e.target.value
        })
      }}
      inputProps={{
        'data-heap-id': 'LoggedOutGenerator_ScanDestinationInputGoogleDoc',
        ref
      }}
      error={!!error}
      helperText={error}
    />
  )
}
